<template>
  <section>
    <div>
      <b-table
        :data="isEmpty ? [] : listeProduitsPanier"
        :mobile-cards="hasMobileCards"
      >
        <template slot-scope="props">
          <b-table-column field="type" label="Type">{{
            props.row.produit.type
          }}</b-table-column>

          <b-table-column field="nom" label="Nom">{{
            props.row.produit.nom
          }}</b-table-column>
          <b-table-column field="contenance" label="Contenance">{{
            `${props.row.produit.quantite} ${props.row.produit.unite}`
          }}</b-table-column>

          <b-table-column field="supplement" label="Supplément">
            <b-collapse
              v-if="props.row.supplement[0]"
              class="card"
              animation="slide"
              :open="isOpen == props.index"
              @open="isOpen = props.index"
            >
              <div
                slot="trigger"
                slot-scope="props"
                class="card-header"
                role="button"
              >
                <p class="card-header-title">oui</p>
                <a class="card-header-icon">
                  <b-icon
                    :icon="props.open ? 'caret-up' : 'caret-down'"
                  ></b-icon>
                </a>
              </div>
              <div class="card-content">
                <div class="content">
                  <ul>
                    <li
                      v-for="supplement in props.row.supplement"
                      :key="supplement"
                    >
                      {{ supplement }}
                    </li>
                  </ul>
                </div>
              </div>
            </b-collapse>
            <span v-else>non</span>
          </b-table-column>

          <b-table-column v-if="!isFreeze" field="quantite" label="Quantité">
            <b-select
              class="is-large"
              @input="modifierQuantite(props.row)"
              v-model="props.row.quantite"
            >
              <option
                v-for="number in props.row.produit.stock"
                :value="number"
                :key="number"
              >
                {{ number }}
              </option>
            </b-select>
          </b-table-column>
          <b-table-column v-else field="quantite" label="Quantité">
            <span>{{ props.row.quantite }}</span>
          </b-table-column>

          <b-table-column field="prix_unitaire" label="Prix Unitaire" centered>
            <span>{{ props.row.produit.prix }} €</span>
          </b-table-column>

          <b-table-column field="total" label="Total">
            <span>{{ props.row.total }} €</span>
          </b-table-column>

          <b-table-column v-if="!isFreeze">
            <b-tooltip
              label="Voir la page du produit."
              type="is-info"
              :delay="500"
            >
              <span
                class="is-clickable"
                @click="detailModal(props.row.produit)"
              >
                <b-icon icon="eye" type="is-info" />
              </span>
            </b-tooltip>
          </b-table-column>

          <b-table-column v-if="!isFreeze" numeric>
            <b-tooltip
              label="Supprimer le produit."
              type="is-danger"
              :delay="500"
            >
              <span class="is-clickable" @click="supprimer(props.row)">
                <b-icon icon="times" type="is-danger" />
              </span>
            </b-tooltip>
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="shopping-basket" size="is-large" />
              </p>
              <p>Votre Panier est vide</p>
            </div>
          </section>
        </template>
      </b-table>
      <div v-show="listeProduitsPanier.length">
        <hr />
        <p class="has-text-centered">
          <b>Prix Livraison : {{ panier.prixLivraison.toFixed(2) }} €</b>
        </p>
        <hr />
        <p class="has-text-centered">
          <b>Prix total : {{ panier.total }} €</b>
        </p>
        <hr />
      </div>
    </div>
  </section>
</template>

<script>
import Panier from "../classes/Panier.js";
import DetailProduit from "@/components/DetailProduit.vue";

export default {
  props: {
    panier: Panier,
    isFreeze: Boolean,
  },
  data() {
    return {
      isOpen: -1,
      isEmpty: false,
      hasMobileCards: true,
      quantiteEdit: 1,
      loaded: false,
      product: {
        price: 0.01,
        description: "Vinaigre Paniqué",
        img: "../assets/infoFruit.jpeg",
      },
    };
  },
  computed: {
    listeProduitsPanier() {
      return this.panier.liste;
    },
  },
  methods: {
    supprimer(produitPanier) {
      this.panier.deleteProduit(produitPanier);
    },
    modifierQuantite(produitPanier) {
      const stockDispo = this.panier.checkStockBeforeEdit(produitPanier);
      if (stockDispo) {
        this.panier.editQuantiteProduit(produitPanier);
      } else {
        this.$buefy.dialog.confirm({
          title: "Erreur",
          message: "Désolé mais nous n'en avons pas autant en stock.",
          type: "is-danger",
          hasIcon: true,
          icon: "frown",
          ariaRole: "alertdialog",
          ariaModal: true,
          canCandel: false,
          onConfirm: () => this.$router.go(0),
        });
      }
    },
    detailModal(produit) {
      this.$buefy.modal.open({
        parent: this,
        props: produit,
        component: DetailProduit,
        width: 1600,
      });
    },
  },
};
</script>
